import classNames from 'classnames'
import * as React from 'react'
import './ProgressChecklist.scss'
import { IProgressChecklistItem } from './ProgressChecklistItem'

export interface IProgressChecklist {
  children:
    | React.ReactElement<IProgressChecklistItem>
    | Array<React.ReactElement<IProgressChecklistItem>>
  className?: string
  style?: React.CSSProperties
}

export class ProgressChecklist extends React.PureComponent<IProgressChecklist> {
  public render() {
    return (
      <ul
        className={classNames('progress-checklist', this.props.className)}
        style={this.props.style}
      >
        {this.props.children}
      </ul>
    )
  }
}
